import { createAction } from '@reduxjs/toolkit';
import { INIT_APP } from './constants';
import type { LayoutOwnProps } from '../../components/Layout/types';

export const initAppAction = createAction<LayoutOwnProps>(INIT_APP);
